import {
  signupFormDataSchema,
  SignupFormLocation,
} from "@redotech/redo-marketing-common/schemas/submit-signup-form-step-schema";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const submitSpotlightStep = {
  name: "submitSpotlightStep" as const,
  input: z.object({
    spotlightId: z.string(),
    stepId: z.string(),
    formData: signupFormDataSchema,
    customerId: z.string().nullable().optional(),
    anonymousId: z.string().optional(),
    treatmentId: z.string().nullish(),
    location: createEnum(SignupFormLocation, { enumName: "SignupFormLocation" })
      .nullish()
      .transform((value) => value ?? SignupFormLocation.SHOPIFY_STOREFRONT),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
    resolvedDiscounts: z.record(z.string(), z.string()).optional(),
  }),
};
